/// <reference path="../../vite-env.d.ts" />
import type { OpsApi } from './ops-client'
import { OpsHttpApi } from './ops-http'
import { OpsMockApi } from './ops-mock'

const baseUrl = import.meta.env?.VITE_API_BASE_URL as string | undefined

export const opsApi: OpsApi = baseUrl ? new OpsHttpApi(baseUrl) : new OpsMockApi()

export { OpsMockApi, OpsHttpApi }
export type { OpsApi, VettingQueueFilters } from './ops-client'
